import React from 'react';
import { useTranslation } from 'react-i18next';
import { Paper, Typography, Container } from '@mui/material';
import { Box } from '@livable/saas-react-components';
import useStyles from './styles';
export default function HowsTab() {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const feeHows = [{
    title: t('fees_page.late_fee'),
    description: t('fees_page.late_fee_desc')
  }, {
    title: t('fees_page.insufficient_funds_fee'),
    description: t('fees_page.insufficient_funds_fee_desc')
  },
  // {
  //   title: 'Resident account maintenance',
  //   description:
  //     'Proin id ligula dictum, convallis enim ut, facilisis massa. Mauris a nisi ut sapien blandit imperdiet sed id lacus. Mauris auctor interdum dignissim. Cras at lacus malesuada, mattis neque mattis, lacinia mauris. Nunc ornare blandit turpis, sit amet dignissim lacus egestas in. Ut in iaculis turpis, ac consequat turpis. Nullam mi tortor, auctor quis orci sed, posuere luctus enim. Ut sollicitudin neque at enim gravida, ut dictum est finibus. Praesent sit amet augue eu tortor pretium vehicula quis et ante. Aenean purus sem, pharetra et ante vel, tincidunt cursus ante.',
  // },
  // {
  //   title: 'Vacancy cost recovery',
  //   description:
  //     'Duis ac augue ut lectus congue luctus. Vivamus eu lacus vestibulum, luctus ante dignissim, interdum orci. Donec in ullamcorper lacus, molestie accumsan tortor. Cras tristique leo nulla, quis condimentum nisi volutpat ut. Praesent non ipsum massa. Vestibulum ut consequat sapien. Curabitur mattis felis id dolor tristique lobortis. Donec mattis nunc ut ornare malesuada. Vivamus id congue ipsum.',
  // },
  {
    title: t('fees_page.paper_statements'),
    description: t('fees_page.paper_statements_desc')
  }, {
    title: t('fees_page.convenience_fee'),
    description: t('fees_page.convenience_fee_desc')
  }
  // {
  //   title: t('fees_page.ach_processing_fee'),
  //   description: t('fees_page.ach_processing_fee_desc'),
  // },
  ];
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.flexGrow
  }, /*#__PURE__*/React.createElement(Container, {
    className: classes.lgSection
  }, feeHows.map(fee => /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper",
    key: fee.title
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, fee.title), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, fee.description)))));
}